import { FC } from 'react';
import 'twin.macro';
import 'styled-components/macro';

export type MenuListProps = {
  title?: string;
};

export const MenuList: FC<MenuListProps> = ({ children, title, ...props }) => (
  <div tw="mt-3" {...props}>
    {title && <h6 tw="mb-1">{title}</h6>}
    {children}
  </div>
);
